// src/components/styles/responsive.ts
import { css } from 'styled-components';

export const responsiveColumnStack = css`
  flex-direction: column !important;
  align-items: flex-start !important;
  justify-content: flex-start !important;
`;
